import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@zola/zola-ui';
import './Header.styles.less';

const Header = ({ wedding, profileImage, published, togglePublishWebsite }) => (
  <div className="mpr-row">
    <div className="mpr-header">
      <div className="mpr-header__couples">
        {profileImage ? (
          <img className="mpr-header__profile-image" src={`${profileImage}?h=40`} alt="Profile" />
        ) : (
          null
        )}
        <h1>{wedding.owner_first_name} & {wedding.partner_first_name}&apos;s Website</h1>
      </div>
      { published
        ? <Button secondary onClick={togglePublishWebsite}>Unpublish Website</Button>
        : <Button error onClick={togglePublishWebsite}>Make Website Visible</Button>}
    </div>
  </div>
);


Header.propTypes = {
  wedding: PropTypes.shape({}).isRequired,
  profileImage: PropTypes.string,
  published: PropTypes.bool.isRequired,
  togglePublishWebsite: PropTypes.func,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/manage/website/ManagePagesRedesign/Header/Header.jsx